import { Pipe, PipeTransform } from '@angular/core';
import { TypeNomenclature } from '@shared/enums/type-nomenclature';
import { typeNomenclature } from '@shared/utils/getTypeNomenclature';

@Pipe({
  name: 'typeNomenclature',
  standalone: true,
})
export class TypeNomenclaturePipe implements PipeTransform {
  transform(hxid: string | null, isComplex: boolean): TypeNomenclature {
    return typeNomenclature(hxid || '', isComplex);
  }
}
